import { useEffect, useState } from "react";
import axios from "axios";
import { AlertTriangle, Loader2 } from "lucide-react";
import { API } from "./shared";
import { usd } from "@/lib/training";

export default function FamiliesTab({ ctx }) {
  const { token, setView, setCommsPreset } = ctx;
  const [fams, setFams] = useState(null);
  const [q, setQ] = useState("");
  const [open, setOpen] = useState("");
  const h = { headers: { "X-Admin-Token": token } };
  const load = () => axios.get(`${API}/admin/families`, h).then((r) => setFams(r.data.families));
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const setPref = async (email, v) => { await axios.put(`${API}/admin/families/prefs`, { email, marketing_opt_out: v }, h); load(); };
  const list = (fams || []).filter((f) => !q || `${f.email} ${f.parent_names.join(" ")} ${f.athletes.map((a) => a.name).join(" ")}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <>
      <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-white">Families</h1>
      <p className="mt-2 text-sm font-medium text-white/50">One record per parent email. Athletes are matched by name and date of birth. Records are never merged automatically when details conflict.</p>
      <input data-testid="families-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search parent, athlete or email" className="mt-5 w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white" />
      {!fams && <Loader2 className="mt-8 animate-spin text-white/40" />}
      <div className="mt-4 space-y-3">
        {list.map((f) => (
          <div key={f.email} data-testid={`family-${f.email}`} className="rounded-2xl bg-white/5 border border-white/10 p-4 md:p-5">
            <button className="w-full text-left flex items-start justify-between gap-3" onClick={() => setOpen(open === f.email ? "" : f.email)} data-testid={`family-toggle-${f.email}`}>
              <div>
                <p className="text-base font-bold text-white">{f.parent_names.join(" / ") || f.email}</p>
                <p className="text-xs font-medium text-white/50">{f.email}{f.phones.length ? ` · ${f.phones.join(", ")}` : ""}</p>
                <p className="mt-1 text-xs font-semibold text-white/60">{f.athletes.map((a) => a.name).join(", ")}</p>
              </div>
              <div className="text-right shrink-0"><p className="text-sm font-bold text-white">{usd(f.total_paid)}</p><p className="text-[11px] text-white/40">{f.registrations.length} registration(s)</p></div>
            </button>
            {f.flags.map((x) => <p key={x} className="mt-2 inline-flex items-center gap-1.5 text-xs font-bold text-amber-300"><AlertTriangle size={12} /> {x}</p>)}
            {open === f.email && (
              <div className="mt-4 border-t border-white/10 pt-4 space-y-4">
                {f.athletes.map((a) => (
                  <div key={a.name + a.dob}>
                    <p className="text-sm font-bold text-white">{a.name} <span className="text-white/40 font-medium">· DOB {a.dob || "—"} · {a.division || "—"} · {a.attended} session(s) attended</span></p>
                    <ul className="mt-1 text-xs text-white/60 space-y-0.5">{a.history.map((h2, i) => <li key={i}>{h2.title} · {h2.start_date} · {h2.payment_status}{h2.active ? " · active" : ""}</li>)}</ul>
                  </div>
                ))}
                <div className="flex flex-wrap items-center gap-3">
                  <label className="flex items-center gap-2 text-xs font-semibold text-white/70"><input type="checkbox" data-testid={`family-optout-${f.email}`} checked={f.marketing_opt_out} onChange={(e) => setPref(f.email, e.target.checked)} className="accent-[#2563EB]" /> Opted out of announcements (program notices still sent)</label>
                  <button data-testid={`family-email-${f.email}`} onClick={() => { setCommsPreset({ filter: { type: "families", emails: [f.email] } }); setView("comms"); }} className="rounded-full border border-white/15 px-3 py-1.5 text-xs font-bold text-white/70">Email family</button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
}
